import { render, staticRenderFns } from "./Offices.vue?vue&type=template&id=1facbfd4&scoped=true&"
import script from "./Offices.vue?vue&type=script&lang=ts&"
export * from "./Offices.vue?vue&type=script&lang=ts&"
import style0 from "./Offices.vue?vue&type=style&index=0&id=1facbfd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1facbfd4",
  null
  
)

export default component.exports